export type ProjectScope = 'mine' | 'all';

export interface ProjectFilters {
  statuses?: string[];
  facilityId?: string | null;
  accountId?: string | null;
  serviceType?: string | null;
  startDateFrom?: string | null;
  startDateTo?: string | null;
}

// AFB-0005: sort options surfaced in the project-work toolbar.
// Default is 'created_desc' (newest first). Persisted in localStorage under
// LS_SORT_KEY (see project-list.tsx).
export type ProjectSort =
  | 'created_desc'   // Newest first (default) — created_at DESC
  | 'created_asc'    // Oldest first — created_at ASC
  | 'start_desc'     // Service date (newest) — start_date DESC NULLS LAST
  | 'due_asc'        // Due date (soonest) — due_date ASC NULLS LAST
  | 'bill_desc';     // Bill amount (high to low) — bill_amount DESC NULLS LAST

export const PROJECT_SORT_OPTIONS: { value: ProjectSort; label: string }[] = [
  { value: 'created_desc', label: 'Newest first' },
  { value: 'created_asc',  label: 'Oldest first' },
  { value: 'start_desc',   label: 'Service date (newest)' },
  { value: 'due_asc',      label: 'Due date (soonest)' },
  { value: 'bill_desc',    label: 'Bill amount (high to low)' },
];
